import { colors } from '@/constants';
import { CarListingShadow } from './car-listing-shadow.component';

export const CarDisplayCardV2Skeleton = () => {
    return (
        <div
            className="flex flex-col relative w-full h-full bg-white rounded-xl max-w-[343px]"
            style={{
                boxShadow: '0 2px 14px 0 rgba(0,0,0,0.08)',
            }}
        >
            {/* Car image skeleton */}

            <div className="relative h-20 w-full rounded-lg bg-cover">
                <CarListingShadow
                    className="absolute w-full top-1 left-0 right-0"
                    color={colors['gray-200']}
                    opacity={1}
                />
            </div>

            {/* Card Main body */}
            <section className="h-full flex-1 flex flex-col p-3">
                <div className="flex gap-1 items-end min-h-14 justify-between">
                    <div className="flex flex-col flex-1 overflow-hidden max-w-[60%]">
                        {/* Car title skeleton */}
                        <Skeleton className="h-5 w-3/4 rounded mb-1" />
                        {/* Car details skeleton */}
                        <Skeleton className="h-3 w-full rounded" />
                    </div>

                    {/* Price section skeleton */}
                    <div className="flex flex-col justify-center items-end gap-0.5 min-w-fit shrink-0">
                        <Skeleton className="h-4 w-16 rounded" />
                        <Skeleton className="h-4 w-20 rounded" />
                        <Skeleton className="h-3 w-16 rounded" />
                    </div>
                </div>
            </section>

            {/* Car Includes Section skeleton */}
            <section className="py-2 px-3 bg-white">
                <div className="flex items-center gap-2">
                    <Skeleton className="h-4 w-16 rounded-full" />
                    <div className="text-gray-600">•</div>
                    <Skeleton className="h-4 w-20 rounded-full" />
                    <div className="text-gray-600">•</div>
                    <Skeleton className="h-4 w-14 rounded-full" />
                </div>
            </section>

            {/* Location Section skeleton */}
            <section className="flex gap-1 items-center px-3 py-2">
                <Skeleton className="w-3 h-3 rounded-full" />
                <Skeleton className="h-3 w-24 rounded" />
            </section>
        </div>
    );
};

const Skeleton = ({ className = '' }: { className?: string }) => (
    <div className={`relative overflow-hidden bg-gray-200 ${className}`}>
        <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200" />
    </div>
);
